<template>
  <div >
    <a-popover
      v-model="visible"
      trigger="click"
      placement="bottomRight"
      overlayClassName="header-notice-wrapper"
      :getPopupContainer="() => $refs.noticeRef.parentElement"
      :autoAdjustOverflow="true"
      :arrowPointAtCenter="true"
      :overlayStyle="{ width: '300px', top: '50px' }"
    >
      <template slot="content">
        <a-spin :spinning="loading">
          <!-- <a-tabs v-model="queryParam.noticeType" @change="changeType">
            <a-tab-pane v-for="d in typeOptions" :key="d.dictValue" :tab="d.dictLabel">
              <a-list style="max-height: 300px; overflow: auto">
                <div
                  v-if="showLoadingMore"
                  slot="loadMore"
                  :style="{ textAlign: 'center', marginTop: '12px', height: '32px', lineHeight: '32px' }"
                >
                  <a-spin v-if="loadingMore" />
                  <a-button v-else @click="onLoadMore"> 查看更多 </a-button>
                </div>
                <a-list-item v-for="(item, index) in list" :key="index">
                  <a-list-item-meta :description="item.createTime">
                    <a slot="title" @click="$refs.noticeDetail.getNotice(item.noticeId)">
                      <ellipsis :length="32" tooltip>{{ item.noticeTitle }}</ellipsis>
                    </a>
                  </a-list-item-meta>
                </a-list-item>
              </a-list>
            </a-tab-pane>
          </a-tabs> -->
          <a-tabs @change="changeType" v-model:activeKey="activeKey">
            <a-tab-pane  tab="通知" :key="1">
              <a-list style="max-height: 300px; overflow: auto">
                <div
                  v-if="showLoadingMore"
                  slot="loadMore"
                  :style="{ textAlign: 'center', marginTop: '12px', height: '32px', lineHeight: '32px' }"
                >
                  <a-spin v-if="loadingMore" />
                  <a-button v-else @click="onLoadMore"> 查看更多 </a-button>
                </div>
                <a-list-item v-for="(item, index) in messList" :key="index">
                  <a-list-item-meta :description="item.alertTime">
                    <a slot="title" @click="$refs.noticeDetailx.getNotice(item, index)">
                      <!-- <ellipsis :length="32" tooltip>{{ item.messageType | filterDict(newsTypeList) }}</ellipsis> -->
                      <a-tooltip>
                        <template slot="title"> {{ item.messageContent }} </template>
                       
                        <div v-if="item.messagesPushRecordStatus=='1'" class="colorBk">  {{ item.messageType | filterDict(newsTypeList) }}</div>
                        <div v-else class="colorCC"> {{ item.messageType | filterDict(newsTypeList) }}</div>
                      </a-tooltip>
                    </a>
                  </a-list-item-meta>
                </a-list-item>
              </a-list>
            </a-tab-pane>

            <a-tab-pane  tab="公告" :key="2">
              <a-list style="max-height: 300px; overflow: auto">
                <div
                  v-if="showLoadingMore"
                  slot="loadMore"
                  :style="{ textAlign: 'center', marginTop: '12px', height: '32px', lineHeight: '32px' }"
                >
                  <a-spin v-if="loadingMore" />
                  <a-button v-else @click="onLoadMore"> 查看更多 </a-button>
                </div>
                <a-list-item v-for="(item, index) in noticeList" :key="index">
                  <a-list-item-meta :description="item.alertTime">
                    <a slot="title" @click="$refs.noticeDetail.getNotice(item)">
                      <!-- <ellipsis :length="32" tooltip v-if="item.messagesPushRecordStatus=='1'" class="colorBk">
                        {{ item.messageContent }}
                      </ellipsis> -->
                      <div v-if="item.messagesPushRecordStatus=='1'" class="colorBk">
                          <ellipsis :length="32" tooltip>
                            {{ item.messageContent }}
                          </ellipsis>
                      </div>
                       <div v-else class="colorCC">
                          <ellipsis :length="32" tooltip>
                            {{ item.messageContent }}
                          </ellipsis>
                      </div>
                    </a>
                  </a-list-item-meta>
                </a-list-item>
              </a-list>
            </a-tab-pane>
          </a-tabs>
        </a-spin>
      </template>
      <!-- 通知图标 -->
      <span @click="fetchNotice" class="header-notice" ref="noticeRef">
        <a-badge :count="messageNum" :overflowCount="99">
          <a-icon style="font-size: 20px" type="bell" />
        </a-badge>
      </span>
    </a-popover>
    <!-- 通知详情弹窗 -->
    <notice-detailx ref="noticeDetailx" :typeOptions="typeOptions" @updateMessage="updateMessage"/>
    <!-- 公告详情弹窗 -->
    <notice-detail ref="noticeDetail" :typeOptions="typeOptions"  @updateMessage="updateMessage"/>
    <!-- 签约喜报 -->
    <first-pop :goodNews="goodNews" @handleClose="goodNews = $event"></first-pop>
  </div>
</template>

<script>
import { listNotice,getMessagesPage,getMessagesRecord } from '@/api/system/notice'
import Ellipsis from '@/components/Ellipsis'
import NoticeDetail from './NoticeDetail'
import NoticeDetailx from './NoticeDetailx'
import FirstPop from '../modal/FirstPop.vue'
import { mapGetters } from 'vuex'

export default {
  name: 'HeaderNotice',
  components: {
    Ellipsis,
    NoticeDetail,
    NoticeDetailx,
    FirstPop
  },
  data () {
    return {
      userId: this.$getters.userInfo.userId,
      ws: null, // WebSocket实例
      time: 30000, // 心跳间隔时间
      messageNum:null,//新消息数量
      reconnectTimer: null, //重连定时器
      lockReconnect:false, //避免重复连接
      timeoutObj :null,//发送心跳的定时
      serverTimeoutObj:null,//没心跳的的定时
      isHeart:false,//是否有心跳
      activeKey:1,
      messList:[],//通知列表数据
      total:5,
      noticeList:[],//公告列表数据
      newsTypeList: [], // 通知类型
      newsDataArr: [], // 通知列表
      goodNews: {}, // 签约喜报
      // goodNews: {
      //   id: null,
      //   messagesPushRecordId: null,
      //   messageType: '1',
      //   messageContent: '恭喜:张冰念 4 战报连连 ',
      //   messageFile: null,
      //   isWhole: 'Y',
      //   alertTime: '2022-05-30 19:21:23',
      //   alertTimeEnd: null,
      //   ext: '{"rentExpense":"4800","signName":"张冰念","signAvatar":"https://gysy-web.obs.cn-north-4.myhuaweicloud.com:443/CORP%2F181c74c6cab84c629687b87f64beac8db"}',
      // }, //签约喜报
      loading: false,
      loadingMore: false,
      showLoadingMore: true,
      visible: false,
      queryParam: {
        pageNum: 1,
        pageSize: 5,
        status: 0,
        noticeType: '1'
      },
      setTime:0,
      messageParam:{
        pageNum: 1,
        pageSize: 5,
        type:1,
        isAsc:1
      },
      list: [],
      typeOptions: [],
      timeConnect: 0
    }
  },
  methods: {
    getList () {
      this.loading = true
      getMessagesPage(this.messageParam).then(res=>{
        this.total=res.data.total
        if(this.messageParam.type==1){
             this.messList=this.messList.concat(res.data.records)
        }else{
            this.noticeList=this.noticeList.concat(res.data.records)
        }
        if (this.total <= this.messageParam.pageNum * this.messageParam.pageSize) {
          this.showLoadingMore = false
        } else {
          this.showLoadingMore = true
        }

        this.loading = false
      })
      // listNotice(this.queryParam).then((response) => {
      //   this.list = this.list.concat(response.rows)
      //   this.total = response.total
      //   if (this.total <= this.queryParam.pageNum * this.queryParam.pageSize) {
      //     this.showLoadingMore = false
      //   } else {
      //     this.showLoadingMore = true
      //   }

      //   this.loading = false
      // })
    },
    //获取未读消息公告总数
    getMessages(){
      getMessagesRecord().then(res=>{
        if(res.code==200){
          this.messageNum=res.data
        }
      })
    },
    updateMessage(){
      this.getMessages()
    },
    //查询消息公告列表数据
    getMessagesPage(){
      getMessagesPage(this.messageParam).then(res=>{
        this.total=res.data.total
        this.messList=res.data.records
      })
    },
    // 点击消息图标
    fetchNotice () {
      this.resetmessageParam()
      if (!this.visible) {
        if (this.typeOptions.length === 0) {
          this.getDicts('sys_notice_type').then((response) => {
            this.typeOptions = response.data
            console.log(this.typeOptions,'typeOptions')
          })
        }
        this.messageParam.type=this.activeKey
        this.getList()
      }
      this.visible = !this.visible
    },
    resetmessageParam(){
      this.messageParam = {
       pageNum: 1,
        pageSize: 5,
        type:1,
        isAsc:1
      }
       this.messList=[]
       this.noticeList=[]
    },
    changeType (key) {
      this.resetmessageParam()
      this.messageParam.type = key
      this.getList()
    },
    onLoadMore () {
      this.loadingMore = true
      this.messageParam.pageNum++
      this.getList()
      this.loadingMore = false
    },
    // 消息已读后
    getIndexFn (index) {
      this.newsDataArr.splice(index, 1)
    },

    // webSocket链接
    initWebSocket (corpId, userId) {
      const that = this
      if (window.WebSocket) {
        // let ws = new WebSocket(`ws://admin.win2biz.cn/prod-api/websocket/${corpId}/${userId}`) // 建立连接
        const ws = new WebSocket(`${process.env.VUE_APP_WS_URL}/websocket/${corpId}/${userId}`) // 建立连接
        // let ws = new WebSocket(`ws://192.168.3.200:8891/websocket/wwdd4205e78119d40c/333`) // 建立连接
        this.ws = ws
        // 服务器连接成功
        ws.onopen = function () {
          console.log('连接成功')
          ws.send('hello') // 给后台发消息
          that.heartbeat() // 开启心跳
          that.newsDataArr = []
        }

        // 服务器连接出错
        ws.onerror = function () {
          console.log('连接出错')
          that.reconnect()
        }
        // 解析信息-监听消息
        ws.onmessage = function (event) {
          // console.log(event.data,'message测试')
          //心跳检测重置
          // that.heartCheck();
          // if (event.data) {
          //   that.isHeart = true
          // }
          if (JSON.parse(event.data).messageType === '1') {
            that.goodNews = JSON.parse(event.data)
            console.log(that.goodNews, '签约喜报-------00-------')
          } else {
            // that.newsDataArr.unshift(JSON.parse(event.data))
            that.setTime=new Date().getTime()
            that.getMessages()
            // console.log(new Date().getTime() - this.setTime, 'event.data')
           
          }
        }
        ws.onclose = function () {
          console.log('连接断开')
          that.reconnect()
        }
      }
    },
    reconnect () {
      // lockReconnect加锁，防⽌onclose、onerror两次重连
     
      if(this.lockReconnect){
        return
      }
      this.timeConnect++
      this.lockReconnect = true
      console.log('重连')
      // 进⾏重连
      this.reconnectTimer && clearTimeout(this.reconnectTimer);
      this.reconnectTimer = setTimeout(() => {
        this.initWebSocket(this.corpId, this.userId)
        this.lockReconnect = false
      }, 1000 * 10)
    },

    // 心跳
    heartbeat () {
      if( this.timeoutObj ){
        clearInterval(this.timeoutObj);
      }
     this.timeoutObj = setInterval(() => {
        this.ws.send('心跳')
      }, this.time)
    },
    // 心跳
    heartCheck(){
        var  self = this;
        this.timeoutObj && clearTimeout(this.timeoutObj);
        this.serverTimeoutObj && clearTimeout(this.serverTimeoutObj);
        this.timeoutObj = setTimeout(function() {
           //这里发送一个心跳，后端收到后，返回一个心跳消息，
            console.log('发送消息，测试后台是否运行中...');
           //任意发一个消息过去，后台接收，在init()中的onmessage收到消息，说明后台没有挂掉，有心跳
            self.ws.send("心跳");

            if (self.isHeart) {
              return
            }
            self.serverTimeoutObj = setTimeout(function() {
            console.log("后台挂掉，没有心跳了....");
            // console.log("打印websocket的地址:" + websocket);
            self.ws.close();
            self.isHeart = false
            // createWebSocket();

            }, self.time);

        },  this.time)
    }
  },
  computed: {
    ...mapGetters(['corpId'])
  },
  created () {
    this.initWebSocket(this.corpId, this.userId)
    // 获取弹窗类型
    this.getDicts('message_type').then((response) => {
      // console.log(response, '---------------------------')
      this.newsTypeList = response.data
    })
    this.getMessages()
  },
  beforeDestroy () {
    // 服务器连接关闭
    this.ws.onclose = function () {
      console.log('连接关闭')
    }
  },
  watch: {
    goodNews: {
      handler: function (newV, oldV) {
        console.log(newV, oldV)
      },
      deep: true
    }
  }
}
</script>

<style lang="css">
.colorBk{
  color: black;
}
.colorCC{
  color: #ccc;
}
.header-notice-wrapper {
  top: 50px !important;
}
</style>
<style lang="less" scoped>
.header-notice {
  display: inline-block;
  transition: all 0.3s;
  cursor: pointer;

  span {
    vertical-align: initial;
  }
}
</style>
